import { createSlice } from "@reduxjs/toolkit";
import { appRestart } from "src/duck/actions";
import { signOutSuccess } from "src/modules/auth/duck/actions";

const initialState = {
  nearbyDevices: {},
  pairedDevices: {}
};

const devicesSlice = createSlice({
  initialState,
  name: "device",
  reducers: {
    addNearbyDevice(state, { payload }) {
      state.nearbyDevices[payload.jid] = payload;
    },
    removeNearbyDevice(state, { payload }) {
      delete state.nearbyDevices[payload];
    },
    updatePairedDevice(state, { payload }) {
      state.pairedDevices[payload.jid] = {
        ...state.pairedDevices[payload.jid],
        ...payload
      };
    },
    receivedRoster(state, { payload }) {
      const devicesObj = payload.reduce((acc, device) => {
        acc[device.jid] = device;
        return acc;
      }, {});

      state.pairedDevices = Object.values(devicesObj).reduce((all, device) => {
        all[device.jid] = device;
        if (state.pairedDevices[device.jid]) {
          all[device.jid].status = state.pairedDevices[device.jid].status;
          all[device.jid].originalName =
            state.pairedDevices[device.jid].originalName;
          all[device.jid].color = state.pairedDevices[device.jid].color;
          all[device.jid].name = state.pairedDevices[device.jid].name;
        }
        return all;
      }, {});
    },
    removePairedDevice(state, { payload }) {
      delete state.pairedDevices[payload];
    },
    receivedPresence(state, { payload }) {
      if (!state.pairedDevices[payload.jid]) return;
      state.pairedDevices[payload.jid] = {
        ...state.pairedDevices[payload.jid],
        ...payload
      };
    }
  },
  extraReducers(builder) {
    builder
      .addCase(appRestart, () => {
        return initialState;
      })
      .addCase(signOutSuccess, () => {
        return initialState;
      });
  }
});

export { devicesSlice };

export default devicesSlice.reducer;
